import { BsArrowRight } from 'react-icons/bs'

import 'swiper/css'
import 'swiper/css/effect-cards'

import * as S from './styles'
import * as Global from '../../styles/index'
import * as Txt from '../../styles/text'

import TurmasPreEscolar from '../../components/TurmasPreEscolar'
import TurmasFundamental from '../../components/TurmasFundamental'
import { Spinner } from '../../components/LoadingSpinner/styles'
import LoadingCard from '../../components/LoadingCard'
import { useGetTurmasQuery } from '../../services/api'

export interface Atividades {
  id: string
  titulo_ativ: string
  desc_ativ: string
  posicao: number
  turma: string
}

const Turmas = () => {
  const { data: turmas } = useGetTurmasQuery()

  const turmasPreEscolar =
    turmas?.filter((t) => t.categoria === 'pre_escolar') || []
  const turmasFundamental =
    turmas?.filter((t) => t.categoria === 'fundamental') || []

  return (
    <>
      <S.QuadroTurmas id="turmas">
        <S.TabNavbar className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <S.TabSelector
              className="nav-link active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home-tab-pane"
              type="button"
              role="tab"
              aria-controls="home-tab-pane"
              aria-selected="true"
            >
              <h6>Pré-escolar</h6>
            </S.TabSelector>
          </li>
          <li className="nav-item" role="presentation">
            <S.TabSelector
              className="nav-link"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile-tab-pane"
              type="button"
              role="tab"
              aria-controls="profile-tab-pane"
              aria-selected="false"
            >
              <h6>Ensino Fundamental</h6>
            </S.TabSelector>
          </li>
        </S.TabNavbar>
        <S.TabBody className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="home-tab-pane"
            role="tabpanel"
            aria-labelledby="home-tab"
            tabIndex={0}
          >
            <Global.Container>
              <Txt.TextMd className="mt-3 mb-0 text-white">
                {turmasPreEscolar.length > 1 && (
                  <>
                    <p>Arraste para o lado</p>
                    <BsArrowRight className="text-white fs-5 ms-2" />
                  </>
                )}
              </Txt.TextMd>
              {turmasPreEscolar.length === 0 && <LoadingCard />}
              <TurmasPreEscolar turmas={turmasPreEscolar} />
            </Global.Container>
          </div>
          <div
            className="tab-pane fade"
            id="profile-tab-pane"
            role="tabpanel"
            aria-labelledby="profile-tab"
            tabIndex={1}
          >
            <Global.Container>
              <Txt.TextMd className="mt-3 mb-0 text-white">
                {turmasPreEscolar.length > 1 && (
                  <>
                    <p>Arraste para o lado</p>
                    <BsArrowRight className="text-white fs-5 ms-2" />
                  </>
                )}
              </Txt.TextMd>
              {turmasPreEscolar.length === 0 && <LoadingCard />}
              <TurmasFundamental turmas={turmasFundamental} />
            </Global.Container>
          </div>
        </S.TabBody>
        <S.LineDivision className="big" />
        <S.LineDivision />
        <S.LineDivision className="small" />
      </S.QuadroTurmas>
    </>
  )
}

export default Turmas
